//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Builder.js";
let d=[[],[[["types"],"EnableCharacteristics",{},1,0],[["types"],"DisableCharacteristics",{},1,0],[[],"GetDatumLetter",{R_:{datumLetter:"MBD.StringCriteriaBuilder"}},0,0],[[],"GetToleranceValue",{R_:{tolValue:"MBD.DoubleCriteriaBuilder"}},0,0]],[]];
SPLM.MBD.PMIQueryFCFCriteriaBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.PMIQueryFCFCriteriaBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.PMIQueryFCFCriteriaBuilder.FcfType = Object.freeze({
    "Default" : "Default", "Straightness" : "Straightness", "Flatness" : "Flatness", "Circular" : "Circular", "Cylindrical" : "Cylindrical", "LineProfile" : "LineProfile", "SurfaceProfile" : "SurfaceProfile", "Angular" : "Angular", "Perpendicular" : "Perpendicular", "Parallel" : "Parallel", "AxisIntersection" : "AxisIntersection", "Position" : "Position", "Concentric" : "Concentric", "Symmetric" : "Symmetric", "CircularRunout" : "CircularRunout", "TotalRunout" : "TotalRunout"});

export default SPLM;